function initTooltip(container) {
  const popUp = container.querySelector(".fn-0020-tooltip-container");
  const opener = container.querySelector(".fn-0020-tooltip-container img");
  const content = container.querySelector(".fn-0020-tooltip-content");

  opener.addEventListener("click", () => {
    popUp.classList.toggle("clicked");
  });

  content.addEventListener("mouseleave", () => {
    popUp.classList.remove("clicked");
  });
}

document.querySelectorAll(".fn-0020-container").forEach(initTooltip);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.classList.contains("fn-0020-container")) {
          initTooltip(node);
        }
        node.querySelectorAll(".fn-0020-container").forEach(initTooltip);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
